// JavaScript Document


$(function(){

	/************************************************************
	PC-SP画像切り替え
	************************************************************/

	//切り替えポイント
	var rwdPoint=600;

	function ImgChange(){
		if($(window).width()<rwdPoint){
            $("img.rwd").each(function(){
				var changeImg = $(this).attr('src').replace('-pc.' , '-sp.');
				$(this).attr('src', changeImg);
			});
		}else{
			$("img.rwd").each(function(){
				var changeImg = $(this).attr('src').replace('-sp.' , '-pc.');
				$(this).attr('src', changeImg);
			});
		}
	}

	//読み込み時の処理
	ImgChange();

    //リサイズ時の処理
    $(window).resize(function () {
		ImgChange();
    });

	/************************************************************
	規定表示
	************************************************************/

	$(".how_detail,.detail_txtLink").on('click', function(event) {
		event.preventDefault();
		coverRayerOn();
		$('.btn-pagetop').css({'display':'none'})
	});

	$('#coverRayer,.close,.present_detailClose').on('click', function(event) {
		$("#coverRayer").animate({opacity:0}, 300,function(){
			$("#coverRayer").css({"display":"none"});
		});
		$('.btn-pagetop').css({'display':''})
	});

	$('.present_detail').on('click', function(event) {
		event.stopPropagation();
	});





	function coverRayerOn(){
		$("#coverRayer").css({"display":"block"});
		$("#coverRayer").animate({opacity:1}, 300,function(){
			$(".photo").css('display', 'inline-block');
		});
	}


});
